export default {
	title: 'Gestión de Tarjetas IoT',
	actions: {
		add: 'Agregar',
                import: 'Importar',
                exportTemplate: 'Exportar Plantilla',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar por Lote',
		expiringSoon: 'Alerta de Vencimiento'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar {count} registro(s) seleccionado(s)?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione el registro a eliminar',
		operateSuccess: 'Operación exitosa',
                requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
                importSuccess: 'Importación exitosa',
                importFailed: 'Importación fallida: ',
                fileTooLarge: 'El archivo no puede superar los 100 MB'
	},
	form: {
		projNo: 'Número de Proyecto',
		number: 'Número de Tarjeta IoT',
		iccid: 'ICCID',
		placeholder: {
			projNo: 'Ingrese el número de proyecto',
			number: 'Ingrese el número de tarjeta IoT',
			iccid: 'Ingrese el ICCID',
			buyDateStart: 'Fecha de compra inicial',
			buyDateEnd: 'Fecha de compra final',
			expireDateStart: 'Fecha de vencimiento inicial',
			expireDateEnd: 'Fecha de vencimiento final'
		}
	},
	table: {
		number: 'Número de Tarjeta IoT',
		iccid: 'ID de Tarjeta IC',
		projNo: 'Número de Proyecto',
		bindType: 'Gateway/Sensor',
		terminalId: 'ID de Terminal',
		sensorId: 'Sensor Relacionado',
		buyDate: 'Fecha de Compra',
		expireDate: 'Fecha de Vencimiento',
		status: 'Estado de la Tarjeta',
		active: 'Estado de Activación',
		trafficMonthly: 'Tráfico Mensual',
		trafficUsed: 'Tráfico Usado (M)',
		serviceCycle: 'Ciclo de Servicio',
		mobileCarrier: 'Operador'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		number: 'Número de Tarjeta IoT',
		iccid: 'ID de Tarjeta IC',
		projNo: 'Proyecto',
		bindType: 'Tipo de Vinculación',
		terminalId: 'ID de Terminal/Gateway',
		sensorId: 'ID de Sensor Relacionado',
		buyDate: 'Fecha de Compra',
		expireDate: 'Fecha de Vencimiento',
		allotDate: 'Fecha de Asignación',
		trafficMonthly: 'Tráfico Mensual',
		trafficUsed: 'Tráfico Usado',
		mobileCarrier: 'Operador',
		serviceCycle: 'Ciclo de Servicio',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			number: 'Ingrese el número de tarjeta IoT',
			iccid: 'Ingrese el ID de tarjeta IC',
			projNo: 'Ingrese el número de proyecto',
			bindType: 'Seleccione el tipo de vinculaciÃ³n',
			terminalId: 'Ingrese el ID de terminal/gateway',
			sensorId: 'Ingrese el ID de sensor relacionado',
			buyDate: 'Seleccione la fecha de compra',
			expireDate: 'Seleccione la fecha de vencimiento',
			allotDate: 'Seleccione la fecha de asignación',
			trafficMonthly: 'Ingrese el tráfico mensual',
			trafficUsed: 'Ingrese el tráfico usado',
			mobileCarrier: 'Seleccione el operador',
			serviceCycle: 'Ingrese el ciclo de servicio'
		},
		options: {
			bindType: {
				gateway: 'Gateway',
				sensor: 'Sensor'
			},
			mobileCarrier: {
				telecom: 'Telecom',
				mobile: 'Móvil',
				unicom: 'Unicom'
			}
		}
	}
}
